export enum NameSpace {
  CatalogData = 'CATALOG_DATA',
  ProductData = 'PRODUCT_DATA',
  ReviewData = 'REVIEW_DATA',
  Order = 'ORDER',
  Sort = 'SORT',
  Filter = 'FILTER',
  APP ='APP'
}
